<template>
    <div class="slide-deck-progress-bar">

        <div class="arrows">
            <div class="close-btn dot" @click="onCloseClick">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.41 91.41"><title>x-icon</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_5" data-name="Layer 5"><line x1="0.71" y1="90.71" x2="90.71" y2="0.71" fill="none"  stroke-miterlimit="10" /><line x1="90.71" y1="90.71" x2="0.71" y2="0.71" fill="none" stroke-miterlimit="10"/></g></g></svg>
            </div>

            <div class="arrow left dot" @click="incrementDeck(-1)">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 60.3 62.4" style="enable-background:new 0 0 60.3 62.4;" xml:space="preserve">
                    <g>
                        <g id="Layer_1-2">
                            <g id="Layer_1-2-2">
                                <polyline class="st0" points="27.4,1.4 57.4,31.5 27.9,61 			"/>
                            </g>
                            <line class="st0" x1="57.4" y1="31.5" x2="0" y2="31.5"/>
                        </g>
                    </g>
                </svg>
            </div>



            <div class="arrow right dot" @click="incrementDeck(1)">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 60.3 62.4" style="enable-background:new 0 0 60.3 62.4;" xml:space="preserve">
                    <g>
                        <g id="Layer_1-2">
                            <g id="Layer_1-2-2">
                                <polyline class="st0" points="27.4,1.4 57.4,31.5 27.9,61 			"/>
                            </g>
                            <line class="st0" x1="57.4" y1="31.5" x2="0" y2="31.5"/>
                        </g>
                    </g>
                </svg>
            </div>
        </div>

        <div class="dots">
            <div class="track"></div>





            <div class="dot" v-for="(slide, index) in slides" :key="index" :class="slide.class" @click="onDotClick(index)" :data-active="(index === value.page)">
                <label class="label" :style="{marginTop:slide.offset?slide.offset:'0'}">{{ slide.label }}</label>
                <label v-if="slide.groupLabel" class="group-label">{{ slide.groupLabel }}</label>
            </div>




        </div>
    </div>
</template>

<script>
    export default {
        name: "slide-deck-progress-bar",
        props: {
            slideDeck: {
                default: function(){
                    return [
                        { slides: [] } //array of sections with slide arrays
                    ];
                }
            },

            value: {
                default: function(){
                    return null
                } //read-only, emit value to change
            },

            title:{
                default: "Title"
            },
            sectionTitle: {
                default: "Section Title"
            }
        },
        mounted: function(){
            this.reveal();
        },

        data: function () {
            return {
                currentSlideIndex: 0
            }
        },
        methods: {

            reveal: function(){
                var dots = this.$el.querySelectorAll(".dot");

                var track = this.$el.querySelectorAll(".track");



                this.$tween.set(track,{ scaleX: 0, opacity: 0, transformOrigin: "0 50%" });
                this.$tween.to(track,0.3, { scaleX: 1.0, opacity: 0.5, delay: 0.5, transformOrigin: "0 50%" });
                dots.forEach((dot, index) => {
                    this.$tween.set(dot,{ opacity: 0 })
                    this.$tween.to(dot, 0.15, { opacity: 1.0, delay: (0.5 + (0.05 * index))})
                })
            },

            hide: function(direction){
                var dots = this.$el.querySelectorAll(".dot");
                var track = this.$el.querySelectorAll(".track");
                this.$tween.to(track,0.15, { scaleX: 0, opacity: 0, transformOrigin: "100% 50%" });
                dots.forEach((dot, index) => {
                    if((index + 1) == dots.length){
                        this.$tween.to(dot, 0.05, { opacity: 0, delay: (0.025 * index), onCompleteParams: [direction], onComplete: (dir)=>{
                                //console.log("emitting increment", dir);
                                this.$emit('increment', dir);
                            } })
                    }else{
                        this.$tween.to(dot, 0.05, { opacity: 0, delay: (0.025 * index) })
                    }

                })
            },

            onDotClick: function(dotIndex){
                this.$emit("input", {
                  ...this.value,
                  page: dotIndex
                });
            },

            onCloseClick: function(){
                this.$emit("close");
            },

            posHash: function(posIndex){
                if(posIndex){
                    return posIndex.category+""+posIndex.section+""+posIndex.group+""+posIndex.page;
                }
            },

            incrementDeck: function(direction){

                if((this.value.page + direction) < 0){
                  this.hide(direction);
                  return;
                }

                if((this.value.page + direction) >= this.slides.length){
                  return
                }

                this.$emit('increment', direction);
            }
        },
        computed: {
            slides: function(){

                if(this.slideDeck && this.slideDeck.slides){
                  return this.slideDeck.slides.map((slide)=>{
                    let slideObj = {...slide};
                    slideObj.class = slide.groupLabel?"large":"small";
                    return slideObj;
                  })
                }

                return [];

            },
        }
    }
</script>

<style scoped>

    @keyframes blink {
        0% {
            background-color: var(--wireframe);
        }

        50% {
            background-color: var(--wireframe-dark);
        }

        100% {
            background-color: var(--wireframe);
        }
    }



    .slide-deck-progress-bar {

        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .dots {
        position: relative;
         display: flex;
         justify-content: space-between;
        align-items: center;
        flex-grow: 1;
    }

    .dot {
        width: 0.75em;
        height: 0.75em;
        position: relative;
        border-radius: 100%;
        border: 2px solid #888;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: black;
        transform: scale(1.0);
        box-sizing: border-box;
        cursor: pointer;

    }



    .dot.large {
        width: 1.5em;
        height: 1.5em;

        border-color: white;
    }

    .dot .label {
        text-align: center;
        position: absolute;
        font-size: 0.7em;

        color: #888;

        width: 7em;
        top: calc(100% + 1em);
        user-select: none;

    }

    .dot .group-label {
        text-align: center;
        position: absolute;
        font-size: 0.7em;

        color: #888;

        width: 6em;
        bottom: calc(100% + 1em);
        user-select: none;

    }

    .dot[data-active="true"]{

        border-color: white;
        border-width: 2px;
        box-shadow: 0 0 20px var(--wireframe);

        animation: blink 1.0s infinite;
    }

    .dot[data-active="true"] .label, .dot[data-active="true"] .group-label{
        color: white;
    }

    .dots .track {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%) scale(1.0);
        height: 1px;
        width: 100%;

        background: white;

    }

    .arrows {
        display: flex;
        margin-right: 3em;
        align-items: center;
    }

    .arrow {
        width: 3em;
        height: 3em;
    }

    .close-btn {
        width: 2em;
        height: 2em;
        border: 2px solid #888;
        border-radius: 100%;
        box-sizing: border-box;
        margin-right: 5em;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0.5em;
    }



    .arrow svg {
        stroke: #fff;
        width: 1.5em;
        stroke-width: 6px;
    }

    .arrow.left svg {
        transform: rotate(180deg);
    }

    .arrow.left {
        margin-right: 1em;
    }

    .arrow.right {



    }


</style>